import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormGroup
} from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';

export class FormUtils {
  /**
   * Réagit aux changements de valeurs du formControl passé en paramètre mais aussi à la valeur initiale.
   */
  static valueChanges<T>(abstractControl: AbstractControl): Observable<T> {
    return abstractControl.valueChanges.pipe(startWith(abstractControl.value));
  }

  static setTouch(formGroup: AbstractControl) {
    FormUtils.applyOnForm(formGroup, (control) => control.markAsTouched());
  }

  static setDirty(formGroup: AbstractControl) {
    FormUtils.applyOnForm(formGroup, (control) => control.markAsDirty());
    FormUtils.setTouch(formGroup);
  }

  static setPristine(formGroup: AbstractControl) {
    if (formGroup) {
      FormUtils.applyOnForm(formGroup, (control) => {
        control.markAsPristine();
        control.markAsUntouched();
      });
    }
  }

  static applyOnForm(
    abstractControl: AbstractControl,
    callback: (control: AbstractControl) => any,
  ) {
    if (abstractControl) {
      if (
        abstractControl instanceof UntypedFormGroup ||
        abstractControl instanceof UntypedFormArray
      ) {
        callback(abstractControl);
        Object.values(abstractControl.controls).forEach((control) =>
          FormUtils.applyOnForm(control, callback),
        );
      } else {
        callback(abstractControl);
      }
    }
  }

  static handleDirty(control: AbstractControl, setDirty: boolean) {
    if (setDirty) {
      FormUtils.setDirty(control);
    } else {
      FormUtils.setPristine(control);
    }
  }
}
